import { render, staticRenderFns } from "./ManifestacaoMensagemTexto.vue?vue&type=template&id=441fe640&"
import script from "./ManifestacaoMensagemTexto.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoMensagemTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports